// NEVER MODIFY THIS FILE

import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_AUTH_SUPABASE_URL || "https://auth.nut.new";
const supabaseAnonKey =
  import.meta.env.VITE_AUTH_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpia2NhdnhpZGp5c2xxbW5iZnV4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAwMDU0MjAsImV4cCI6MjA1NTU4MTQyMH0.xHKTareBFW0LW0AmYXH0vOvU3mLB3jkQGwhoNWqpnTw";

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Supabase URL and Anon Key must be defined in environment variables.");
}

const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Override fetch() on netlify calls to always include the access token for the current user.
const baseFetch = window.fetch;
window.fetch = async (input, options) => {
  // Extract URL from input (could be string, URL object, or Request object).
  let url: string;
  if (typeof input === "string") {
    url = input;
  } else if (input instanceof URL) {
    url = input.href;
  } else if (input instanceof Request) {
    url = input.url;
  } else {
    // Anything that stringifies to a URL.
    url = String(input);
  }

  if (url.includes("/.netlify/functions/")) {
    // Try to add access token to all Netlify function calls.
    const session = await auth.getSession();
    const accessToken = session?.data.session?.access_token;

    if (accessToken) {
      // Handle different input types appropriately.
      if (input instanceof Request) {
        // Clone the request and merge options with authorization header.
        const modifiedInput = new Request(input, {
          ...options,
          headers: {
            ...Object.fromEntries(input.headers.entries()),
            ...options?.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        });
        // Clear options since they're now merged into the Request.
        const modifiedOptions = undefined;
        return baseFetch(modifiedInput, modifiedOptions);
      }
      // For string or URL inputs, modify options.
      const modifiedOptions = {
        ...options,
        headers: {
          ...options?.headers,
          Authorization: `Bearer ${accessToken}`,
        },
      };
      return baseFetch(input, modifiedOptions);
    }
  }

  return baseFetch(input, options);
};

export function authRequired() {
  return import.meta.env.VITE_AUTH_REQUIRED;
}

export const auth = supabase.auth;
export const users = supabase.from("users");
export default supabase.auth;
